import { CheckCircleFilled } from "@ant-design/icons";
import { Button, Modal } from "antd";
import React from "react";
import "./UserHoldingsPage.css";
import "./HoldingsActionSuccessModal.css";

const RECT_BTN = "user-holdings-rect-modal-btn";

export function HoldingsActionSuccessModal(props: {
  open: boolean;
  title: string;
  description: string;
  onGoHoldings: () => void;
  onStay: () => void;
}): JSX.Element {
  const { open, title, description, onGoHoldings, onStay } = props;
  return (
    <Modal
      open={open}
      title={null}
      footer={null}
      closable={false}
      centered
      width={420}
      destroyOnClose
      className="uh-action-success-modal"
      onCancel={onStay}
    >
      <div className="uh-action-success-body">
        <CheckCircleFilled className="uh-action-success-icon" />
        <div className="uh-action-success-title">{title}</div>
        <div className="uh-action-success-desc">{description}</div>
        <div className="uh-action-success-actions">
          <Button
            className={`${RECT_BTN} uh-action-success-btn`}
            style={{ minWidth: 120 }}
            onClick={onGoHoldings}
          >
            前往我的持仓
          </Button>
          <Button
            type="primary"
            className={`${RECT_BTN} uh-action-success-btn`}
            style={{ minWidth: 120 }}
            onClick={onStay}
          >
            留在本页
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export function HoldingsNoPermissionModal(props: {
  open: boolean;
  onClose: () => void;
}): JSX.Element {
  const { open, onClose } = props;
  return (
    <Modal
      open={open}
      title={null}
      footer={null}
      centered
      width={400}
      destroyOnClose
      className="uh-action-success-modal"
      onCancel={onClose}
    >
      <div className="uh-action-success-body">
        <div className="uh-action-success-title">暂无权限</div>
        <div className="uh-action-success-desc">
          您尚未开通持仓复盘，订阅后即可添加持仓与自选。
        </div>
        <div className="uh-action-success-actions uh-action-success-actions--single">
          <Button
            type="primary"
            className={`${RECT_BTN} uh-action-success-btn`}
            style={{ minWidth: 120 }}
            onClick={onClose}
          >
            知道了
          </Button>
        </div>
      </div>
    </Modal>
  );
}
